import script from "./OsbSetFootDimensions.vue?vue&type=script&setup=true&lang=js"
export * from "./OsbSetFootDimensions.vue?vue&type=script&setup=true&lang=js"

import "./OsbSetFootDimensions.vue?vue&type=style&index=0&id=c6e43cdc&lang=css"
import "./OsbSetFootDimensions.vue?vue&type=style&index=1&id=c6e43cdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e43cdc"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QField from 'quasar/src/components/field/QField.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QForm,QSkeleton,QField,QToolbar,QSeparator,QOptionGroup,QPageSticky,QBtn,QSpinnerHourglass,QSlider});qInstall(script, 'directives', {TouchPan});
